import SupportDashboard from './SupportDashboard';

export default SupportDashboard; 